import React from "react";
import hello_en from "./assets/marquee/hello_en.svg";
import hello_sp from "./assets/marquee/hello_sp.svg";
import hello_fr from "./assets/marquee/hello_fr.svg";
import hello_de from "./assets/marquee/hello_de.svg";
import hello_gr from "./assets/marquee/hello_gr.svg";
import hello_ru from "./assets/marquee/hello_ru.svg";
import hello_ar from "./assets/marquee/hello_ar.svg";
import hello_kr from "./assets/marquee/hello_kr.svg";
import hello_jp from "./assets/marquee/hello_jp.svg";
import hello_cn from "./assets/marquee/hello_cn.svg";

function MarqueeFragment() {
    return (
        <>
        <li><img src={hello_en} alt={"hello_en"}/></li>
        <li><img src={hello_cn} alt={"hello_cn"}/></li>
        <li><img src={hello_sp} alt={"hello_sp"}/></li>
        <li><img src={hello_jp} alt={"hello_jp"}/></li>
        <li><img src={hello_fr} alt={"hello_fr"}/></li>
        <li><img src={hello_kr} alt={"hello_kr"}/></li>
        <li><img src={hello_de} alt={"hello_de"}/></li>
        <li><img src={hello_gr} alt={"hello_gr"}/></li>
        <li><img src={hello_ru} alt={"hello_ru"}/></li>
        <li><img src={hello_ar} alt={"hello_ar"}/></li>
        </>
    )
}

export default function HelloMarquee() {
    return (
        <div className="marquee-container">
            <ul className="marquee">
                <MarqueeFragment/>
                <MarqueeFragment/>
                <MarqueeFragment/>
                <MarqueeFragment/>
                <MarqueeFragment/>
            </ul>
        </div>
    )
}